/**
 * Alert threshold helpers (frontend) — keep logic in sync with controller/src/alertSettings.ts
 */

import type { AlertThresholdsConfig } from '../types/alerts';

export function isRoomAlertsDeliveryEnabled(
  roomId: string | undefined,
  globalAlertsEnabled: boolean,
  roomOverrides?: AlertThresholdsConfig['roomOverrides'],
): boolean {
  if (!roomId) return globalAlertsEnabled;
  if (roomOverrides?.[roomId]?.alertsEnabled === false) return false;
  return globalAlertsEnabled;
}
